import request from '@/utils/request'

// 获取通知类型
export const getNoticeTypeApi = () => request({
  url: '/ir/article/categoryList',
  method: 'get'
})
// 获取通知列表
export const getNoticeListApi = (data) => request({
  url: '/ir/article/getArticleList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})
// 获取周历事项列表
export const getWeekWorkListApi = (data) => request({
  url: '/wc/work/getWeekWorkList',
  method: 'post',
  data,
  headers: { 'Content-Type': 'application/json' }
})